import * as React from "react"
import ProductFilterType from "../../../model/ProductFilterType"
import AccordionHeader from "../../accordion/AccordionHeader"
import AccordionBody from "../../accordion/AccordionBody"
import AccordionItem from "../../accordion/AccordionItem"
import Deselect from "../../deselect/deselect"
import { Checkbox } from "semantic-ui-react"
import { BrandType, ProductType } from "model"

const BrandFilter: ProductFilterType = ({ state, onChange, allProducts, ...props }) => {
  const allBrands = getAllBrands(allProducts).sort((a, b) => (a?.slug > b?.slug ? 1 : -1))
  const selectedBrands: string[] = state || []

  const handleChange = brandSlug => {
    if (selectedBrands.includes(brandSlug)) {
      const newList = [...selectedBrands]
      newList.splice(newList.indexOf(brandSlug), 1)
      onChange(newList)
    } else {
      onChange([...selectedBrands, brandSlug])
    }
  }

  return (
    <AccordionItem {...props}>
      <AccordionHeader>
        Brands {selectedBrands.length > 0 && <small>{selectedBrands.length} selected</small>}
      </AccordionHeader>
      <AccordionBody>
        {allBrands.map(brand =>
          brand ? (
            <div key={brand.slug}>
              <Checkbox
                key={brand.name}
                label={brand.name}
                onChange={() => handleChange(brand.slug)}
                checked={selectedBrands.includes(brand.slug)}
              />
            </div>
          ) : null
        )}
        <Deselect onChange={onChange} selectedItems={selectedBrands} />
      </AccordionBody>
    </AccordionItem>
  )
}

const getAllBrands = (products: ProductType[]): BrandType[] => {
  const brandSlugs: string[] = []
  const brands: BrandType[] = []

  products.forEach(product => {
    if (!brandSlugs.includes(product.brand?.slug)) {
      brandSlugs.push(product.brand?.slug)
      brands.push(product.brand)
    }
  })
  return brands
}

BrandFilter.filter = (product: ProductType, state: any) => {
  if (!state || state.length < 1) {
    return true
  } else {
    return state.includes(product.brand?.slug)
  }
}
BrandFilter.filterName = "brands"

export default BrandFilter
